// extracted by mini-css-extract-plugin
export default {"container":"CodeView_container__1SJe3","name":"CodeView_name__VQ3A9","section":"CodeView_section__0V-lh"};